export const isAddressPopulated = (
  address: any,
  addressDefaultFields: string[],
  defaultValue: string,
) => {
  return addressDefaultFields.every((field) => address[field] !== defaultValue)
}

export const isCollectionAndDeliveryAddressPopulated = (
  collectionAddresses: any[],
  deliveryAddresses: any[],
) => {
  const defaultValue = ''
  const addressDefaultFields = ['name', 'addressLine1', 'city', 'postcode', 'country']

  if (collectionAddresses.length > 0 && deliveryAddresses.length > 0) {
    return (
      isAddressPopulated(collectionAddresses[0], addressDefaultFields, defaultValue) &&
      isAddressPopulated(deliveryAddresses[0], addressDefaultFields, defaultValue)
    )
  }

  return false
}

export const getWaitAndReturnTooltipText = (
  collectionAddresses: any[],
  deliveryAddresses: any[],
  customerId?: string,
) => {
  if (!customerId) {
    return 'A customer must be selected to enable "Wait and Return" option.'
  }

  const showWaitAndReturnTooltip = collectionAddresses && collectionAddresses.length > 1

  if (showWaitAndReturnTooltip) {
    return 'The booking has more than one Collection Address. "Wait and Return" option cannot be selected.'
  }

  if (!isCollectionAndDeliveryAddressPopulated(collectionAddresses, deliveryAddresses)) {
    return 'Both Collection and Delivery addresses mandatory fields must be populated to enable "Wait and Return" option.'
  }

  return 'This checkbox adds Wait & Return charges for jobs requiring a return journey.'
}
